import { getUUid } from '@/utils/tools'
import { useSetState } from 'ahooks'
import { Button, Space } from 'antd'
import { useRef } from 'react'
import { Column, Editors, GridOption, SlickgridReact, SlickgridReactInstance } from 'slickgrid-react'
import styles from './index.module.less'
import CustomTextEditor from '../../CustomTextEditor'
import SlickGridComponent from '../../index'

const dataSource = Array.from(Array(10).keys()).map(i => {
    return {
        id: i,
        name: `输入中文或者英文`
    }
})

const Index = (props: any) => {
    const gridRef = useRef<SlickgridReactInstance | null>(null);
    const [state, setState] = useSetState({
        loading: false,
        height: 400,
        dataSource: dataSource,
        modalVisible: false,
        changedCellValue: '',
    })

    // 自定义样式
    const customStyles = document.createElement('style');
    customStyles.textContent = `
    .slick-cell {
      caret-color: transparent !important;
    }
    .slick-cell.editing {
      caret-color: black !important;
      outline: none !important;
    }
  `;
    document.head.appendChild(customStyles);

    const gridOptions: GridOption = {
        gridWidth: '100%',
        autoEdit: true, // 禁用默认的编辑行为
        editable: true,
        autoCommitEdit: true, // 是否自动提交编辑
        enableCellNavigation: true,
        // enableFiltering: true,
        multiColumnSort: false,
        enableRowSelection: true,
        autoResize: {
            container: '#indicator_zjzb_table_container',
            rightPadding: 0,
            bottomPadding: 0,
            calculateAvailableSizeBy: 'container'
        },
        enableAutoResize: true,
        // enableTreeData: true,
        // treeDataOptions: {
        //     identifierPropName: 'id',
        //     columnId: 'name',
        //     childrenPropName: 'children',
        //     autoApproveParentItemWhenTreeColumnIsValid: true,
        //     autoRecalcTotalsOnFilterChange: false,
        //     excludeChildrenWhenFilteringTree: false,
        //     initialSort: { columnId: 'sort', direction: 'asc' }
        // },
    }
    const collection = [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
    ]

    const columns: Column[] = [
        {
            id: 'id',
            name: '',
            field: 'id',
            minWidth: 60,
            maxWidth: 70,
            cssClass: 'slickgrid_column_number slickgrid-checkbox-center-cls',
            behavior: "select",
            sortable: true,
            editor: {
                model: Editors.Text
            }
        },
        {
            id: 'name',
            field: 'name',
            name: '名称1',
            minWidth: 360,
            cssClass: 'slickgrid-edit',
            editor: {
                model: CustomTextEditor
            }
        },
        {
            id: 'name2',
            field: 'name2',
            name: '下拉',
            editor: {
                model: Editors.singleSelect,
                // collectionFilterBy: 'value'
                collection: collection,
                collectionOverride(collectionInput, args) {
                    const { dataContext } = args
                    if (dataContext.id === 3) {
                        return collection.filter(item => item.value == '3')
                    }
                    console.log('collectionInput: ', collectionInput, args)
                    return collection
                },
            }
        },
        {
            id: 'name3',
            field: 'name3',
            name: '名称3(不可编辑)',
        }
    ]

    const getDatasource = number => {
        return Array.from(Array(number).keys()).map(i => {
            return {
                id: i,
                name: `指标科目${i}`
            }
        })
    }

    const handleClick = () => {
        setState({
            height: 500
        })
    }

    const handlePosition = (visibleRow = 22) => {
    }

    const handleSetData = () => {
        setState({ loading: true })
        const newData = getDatasource(50000)
        setState({
            dataSource: newData
        })
        setTimeout(() => {
            setState({ loading: false })

        }, 300);

        setTimeout(() => {
            handlePosition()
        }, 500);
    }

    const handleResize = () => {
        gridRef.current.slickGrid.resizeCanvas();
        // 只调整高度
        const container = document.getElementById('indicator_zjzb_table_container');
        if (container) {
            container.style.height = '300px';
        }
    }

    const handleClick5 = () => {
        setState({ loading: true })
        const newData = getDatasource(5)
        setState({
            dataSource: newData
        })
        setTimeout(() => {
            setState({ loading: false })

        }, 300);

        setTimeout(() => {
            handlePosition()
        }, 500);
    }



    const handleAddBlankRow = () => {
        const newRow = {
            id: getUUid(),
            name: ''
        }
        const insertNumber = gridRef.current.dataView.getLength()
        gridRef.current.dataView.insertItem(0, newRow)
    }

    const handleCellChange = (e: any) => {
        console.log('handleCellChange: ', e)
    }


    console.log("state.loading", state.loading)

    return (<div>
        <div className='flex'>
            <Space style={{ paddingBottom: '18px' }}>
                <Button className='' onClick={handleResize}>resize</Button>
                <Button className='' onClick={handleClick5}>设置5</Button>
                <Button className='' onClick={handleClick}>设置500</Button>
                <Button className='' onClick={handleSetData}>设置50000</Button>
                <Button className='' onClick={handleAddBlankRow}>添加空白行</Button>
                <Button className='' onClick={() => handlePosition}>定位</Button>
            </Space>
        </div>
        <div className={styles['tableWrapper']} style={{ height: `${state.height}px`, position: 'relative' }} id='indicator_zjzb_table_container'>
            <SlickGridComponent
                loading={state.loading}
                gridId='indicator_zjzb_grid'
                gridOptions={gridOptions}
                onCellChange={handleCellChange}
                columnDefinitions={columns}
                dataset={state.dataSource}
            />
            <div style={{ padding: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="text-ellipsis">
                改变的单元格的值：{state.changedCellValue}
            </div>
        </div>

    </div>)
}

export default Index

